export const securedPagesConfig = ['/my-account/', '/checkout', '/cart']
